<template>
  <el-dialog
    :title="model.id > 1 ? '编辑发货' : '新增发货'"
    :visible.sync="visible"
    width="960px"
    @close="$emit('update:show', false)"
    @open="getStoreItemsInfo"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="100px"
      size="small"
    >
      <el-form-item label="发货方式">
        <el-radio-group v-model="model.category_id" :disabled="model.id > 0">
          <el-radio size="small" :label="1">仓库发货</el-radio>
          <el-radio size="small" :label="3">供应商发货</el-radio>
        </el-radio-group>
      </el-form-item>
      <template v-if="model.category_id == 3">
        <el-form-item label="供应商" prop="supplier_id">
          <el-select
            size="small"
            class="fix-width"
            filterable
            placeholder="请选择"
            v-model="model.supplier_id"
          >
            <el-option
              v-for="item in suppliers"
              :key="item.id"
              :label="item.name"
              :value="parseInt(item.id)"
            ></el-option>
          </el-select>
        </el-form-item>
      </template>
      <el-form-item
        :label="model.category_id == 3 ? '发货时间' : '出库日期'"
        prop="stock_out_date"
      >
        <el-date-picker
          v-model="model.stock_out_date"
          size="small"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </el-form-item>
      <el-form-item class="list" label="产品明细" prop="items">
        <el-table
          v-if="model.items && model.items.length > 0"
          :data="model.items"
        >
          <el-table-column label="对象" width="60px">
            <template slot-scope="scope">{{
              scope.row.item.category == 1 ? '零件' : '设备'
            }}</template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="item.name"
            label="名称"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="item.part_number"
            label="件号"
            width="120px"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="item.machine_type"
            label="机型"
            width="120px"
          ></el-table-column>
          <el-table-column
            align="center"
            label="仓库"
            v-if="model.category_id == 1"
          >
            <template slot-scope="scope">
              <span
                :class="{ 'text-danger': scope.row.stockroom.id == 0 }"
                v-if="scope.row.stockroom"
                >{{ scope.row.stockroom.name }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="item.price"
            label="定价"
            width="120px"
          >
            <template slot-scope="scope">{{
              scope.row.price.toFixed(2)
            }}</template>
          </el-table-column>
          <el-table-column align="center" label="数量" width="120px">
            <template slot-scope="scope">
              <el-input-number
                v-model="scope.row.number"
                style="width: 100px"
                size="mini"
                type="number"
                :disabled="scope.row.fixedNumber"
                :min="1"
                :max="1000"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column width="50">
            <template slot-scope="scope">
              <el-button
                type="text"
                class="text-danger"
                @click="removeItem(scope.$index)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class>
          <el-button
            v-if="orderItems.length == 0"
            size="small"
            icon="el-icon-plus"
            type="primary"
            @click="itemSelectorVisible = true"
            >添加</el-button
          >

          <el-popover
            v-else
            placement="right-start"
            trigger="click"
            v-model="orderItemVisbile"
            style="max-width: 80%; width: 400px"
          >
            <div class="order-items">
              <div class="header">
                <h2>订单发货清单</h2>
              </div>
              <ul class="item-list" v-if="orderItems.length > 0">
                <template v-for="(item, index) in orderItems">
                  <li
                    class="flex-row-between"
                    @click="addShippingItem(item, index)"
                  >
                    <span>{{ item.item.name }}</span>
                    <span>x{{ item.count }}</span>
                  </li>
                </template>
              </ul>
              <div v-else class="text-info-12 mt-10">
                订单产品已全部加入发货单
              </div>
            </div>
            <el-button
              class="toggle-button"
              type="primary"
              icon="el-icon-view"
              size="mini"
              slot="reference"
              plain
              >订单清单</el-button
            >
          </el-popover>
        </div>
      </el-form-item>
      <el-form-item label="物流单号">
        <el-input
          v-model="model.express_number"
          size="small"
          placeholder="请输入物流单号"
          class="fix-width"
        ></el-input>
      </el-form-item>
      <el-form-item label="物流公司">
        <el-input
          class="fix-width"
          v-model="model.express_company"
          size="small"
          placeholder="请输入物流公司"
        ></el-input>
      </el-form-item>
      <el-form-item label="备注">
        <el-input
          v-model="model.remark"
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 8 }"
          class="fix-width"
          size="small"
          autocomplete="off"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm"
        >确 定</el-button
      >
    </div>

    <item-device-selector
      :show.sync="itemSelectorVisible"
      :selection="model.items"
      :inner="true"
      :multiple="true"
      @selected="doneSelectedItems"
    ></item-device-selector>
  </el-dialog>
</template>

<script>
import ItemDeviceSelector from '@/components/item_selector'
import {
  selectStoreItemList,
  supplierList,
  createStockOutBill,
  updateStockOutBill,
} from '@/service/getData'
import { clone } from '@/util'

export default {
  components: {
    ItemDeviceSelector,
  },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
    products: {
      type: Array,
      default: [],
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  computed: {
    orderItems() {
      var items = []
      this.products.map((product) => {
        items.push(product)
      })

      if (this.model.items) {
        items = items.filter((i) => {
          return !this.model.items.some((j) => i.item.id == j.item.id)
        })
      }

      if (items.length == 0) {
        this.orderItemVisbile = false
      }
      return items
    },
  },
  created() {
    this.requestSuppliers()
  },
  data() {
    return {
      visible: this.show,
      orderItemVisbile: false,
      itemSelectorVisible: false,
      order: null,
      suppliers: [],
      rules: {
        stock_out_date: [{ required: true, message: '请选择时间' }],
        supplier_id: [{ required: true, message: '请选择供应商' }],
        items: [
          {
            type: 'array',
            required: true,
            message: '请至少选择一个产品',
            trigger: 'change',
          },
        ],
      },
    }
  },
  methods: {
    async requestSuppliers() {
      let res = await supplierList({ page: 0, size: 1000 })
      if (res.code == 0) {
        this.suppliers = res.data.list
      }
    },
    removeItem(index) {
      this.model.items.splice(index, 1)
    },

    async getStoreItemsInfo() {
      let itemIDs = this.model.items.map((i) => {
        return parseInt(i.item.id)
      })

      if (itemIDs.length == 0) {
        return
      }

      let itemIDstring = itemIDs.join('&item_ids=')
      let res = await selectStoreItemList({
        item_ids: itemIDstring,
      })
      let store_items = res.data.list
      this.model.items.map((it) => {
        let stockroom = { name: '库存不足', id: 0 }
        if (store_items) {
          let store_item = store_items.filter(
            (s) => s.item_id == it.item.id && s.count >= it.number
          )
          if (store_item.length > 0) {
            stockroom = store_item[0].stockroom
          }
        }

        this.$set(it, 'stockroom', stockroom)
        this.$set(it, 'stockroom_id', stockroom.id)
      })
    },

    addShippingItem(item, index) {
      item.number = item.count
      item.fixedNumber = true
      this.model.items.push(item)
      this.getStoreItemsInfo()
      this.$refs.form.validateField('items')
    },
    doneSelectedItems(items) {
      let ritems = items.map((item) => {
        let ritem = {}
        ritem.number = 1
        ritem.price = item.price
        ritem.item = item
        return ritem
      })
      this.model.items = this.model.items.concat(ritems)
      this.getStoreItemsInfo()
      this.$refs.form.validateField('items')
    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.model.supplier_id = this.model.supplier_id || 0
          this.model.items.map((item) => {
            item.item_id = item.item.id
          })
          if (this.model.id > 0) {
            let res = await updateStockOutBill(this.model)
            if (res.code == 0) {
              this.$emit('updated', res.data)
            }
          } else {
            let res = await createStockOutBill(this.model)
            if (res.code == 0) {
              this.$emit('created', res.data)
            }
          }
          this.visible = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>
<style scoped>
.fix-width {
  width: 220px;
}
.item-list li {
  cursor: pointer;
}

.order-items h2 {
  font-size: 14px;
  color: #555;
  margin-bottom: 10px;
}

.order-items ul li {
  padding: 6px 0;
}

.order-items ul li:hover {
  background-color: #f9f9f9;
}
</style>